import envelopesService from '@/services/envelopes.service'

import { EnvelopesActionTypes } from './action_types'
import { EnvelopesMutationTypes } from './mutation_types'

export const actions : StoreActions<EnvelopesActionTypes, EnvelopesMutationTypes> = {
  async [EnvelopesActionTypes.GET_MY_ENVELOPES] ({ commit }, { mnemo, queryObject }) {
    commit(EnvelopesMutationTypes.SET_MY_ENVELOPES_PENDING, true)
    try {
      const { data } = await envelopesService.getMyEnvelopes(mnemo, queryObject)
      commit(EnvelopesMutationTypes.SET_MY_ENVELOPES, data)
    } catch (error) {
      commit(EnvelopesMutationTypes.SET_MY_ENVELOPES_ERROR, error)
    } finally {
      commit(EnvelopesMutationTypes.SET_MY_ENVELOPES_PENDING, false)
    }
  },
}